// Set Buy Now flag when user clicks the Buy Now button (capture + safe target)
document.addEventListener('teeinblue-event-component-injected', function () {
  // Mặc định flag là false
  globalThis.__tee_buy_now = false;
  const buyNowButton = document.getElementById('teeBuynowButton');
  // Khi nào click vào Buy Now thì mới set flag này true
  buyNowButton?.addEventListener('click', function () {
    globalThis.__tee_buy_now = true;
  });
});

document.addEventListener('teeinblue-event-after-cart-added', function () {
  console.log('Teeinblue: after cart added event triggered ===', globalThis.__tee_buy_now);
  if (globalThis.__tee_buy_now) {
    // If Buy Now, do not show the modal
    return;
  } else {
    // Show popup confirm for Add to Cart action
    const modal = document.getElementById('tee_add_to_cart_confirm');

    modal.style.display = 'block';

    const confirmButtons = modal.querySelector('[data-confirm-modal]');
    const closeButtons = modal.querySelectorAll('[data-close-modal]');
    const imageContainer = modal.querySelector('.confirm-modal--image');
    const optionsContainer = modal.querySelector('.confirm-modal--options');
    imageContainer.innerHTML =
      '<span class="tee-spinner tee-spinner--sm"><svg xmlns="http://www.w3.org/2000/svg" version="1.0" viewBox="0 0 128 128" class="tee-icon-loading tee-icon-loading--sm"><g><path d="M64 127.75A63.76 63.76 0 0152.8 1.23v14.23a49.8 49.8 0 1022.4 0V1.23A63.76 63.76 0 0164 127.75z"></path><animateTransform attributeName="transform" type="rotate" from="0 64 64" to="360 64 64" dur="1260ms" repeatCount="indefinite"></animateTransform></g></svg></span>';

    for (const button of closeButtons) {
      button.addEventListener('click', () => (modal.style.display = 'none'));
    }
    confirmButtons.addEventListener('click', () => {
      // navigate to cart page
      globalThis.location.href = '/cart';
    });

    // Get cart data
    fetch('/cart.js')
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        // Update cart quantity
        globalThis.refreshCart(data);

        // Get customization image and options
        const customizeImage = data.items[0].properties._customization_image;
        const optionsWithValues = data.items[0].options_with_values;

        // Update image
        if (customizeImage) {
          const img = new Image();
          img.src = customizeImage;
          img.alt = 'Customize Image';
          img.width = 170;
          img.height = 170;

          img.onerror = function () {
            // Retry after 500ms
            let assignImage = setInterval(() => (img.src = customizeImage), 500);
            // Clear the interval after 5 seconds
            setTimeout(() => {
              clearInterval(assignImage);
              console.error('Teeinblue: Failed to load image after retry:', customizeImage);
              console.log('Teeinblue: Failed to load image', img);
            }, 5000);
          };

          // onload function ensures the image is fully loaded before displaying
          img.onload = function () {
            imageContainer.innerHTML = '';
            imageContainer.appendChild(img);
          };
        }

        // Update options
        if (optionsWithValues) {
          optionsContainer.innerHTML = '';
          for (const option of optionsWithValues) {
            optionsContainer.innerHTML += `<div>${option.name}: ${option.value}</div>`;
          }
        }
      })
      .catch((error) => {
        console.error('Error fetching cart data:', error);
      });
  }
});
